import { useEffect, useRef, useState } from "react";
import { ReactNode, ReactElement, isValidElement } from "react";
import { useGSAP } from "@gsap/react";
import Lottie from "lottie-react";
import intro from "../assets/lottie/3-tr-in-Color.json";
import outro from "../assets/lottie/3-tr-out-Сolor.json";

interface TransitionLayoutProps {
  children: ReactNode;
}

export default function TransitionLayout({ children }: TransitionLayoutProps) {
  const [displayChildren, setDisplayChildren] = useState<ReactNode>(children);
  const [animationState, setAnimationState] = useState<"init" | "intro" | "outro">("init");

  const lottieIntroRef = useRef(null);
  const lottieOutroRef = useRef(null);


  useGSAP(() => {
    if (
      isValidElement(children) &&
      isValidElement(displayChildren) &&
      children.key !== displayChildren.key
    ) {
      setAnimationState("outro");

      setTimeout(() => {
        window.scrollTo(0, 0);
        setDisplayChildren(children);
        setAnimationState("intro");
      }, 1200);
    }
  }, [children]);
  

  // useEffect(()=> {
  //   if (animationState === 'outro') {

  //     console.log('outro')
  //     // lottieOutroRef.current.stop()
  //     // lottieOutroRef.current.play()
  //   }

  //   if (animationState === 'intro') {
  //           console.log('intro')

  //     // lottieIntroRef.current.stop()
  //     // lottieIntroRef.current.play()
  //   }

  // }, [animationState])

  return (
    <>

      {/* <div className="fixed z-50 pointer-events-none inset-0">
       <Lottie  className="lottie-fill" style={{
          inset: 0,
          position: "absolute",
          display: 'flex',
          justifyContent: 'center',
          rendererSettings: {
           preserveAspectRatio: 'xMidYMid slice' },

          
          opacity: animationState === "intro" ? 1 : 0,
        }} lottieRef={lottieIntroRef} loop={true}  autoplay={true} animationData={outro}></Lottie>
       <Lottie  className="lottie-fill" style={{
          position: "absolute",
          display: 'flex',
          rendererSettings: {
           preserveAspectRatio: 'xMidYMid slice' },
          justifyContent: 'center',
          inset: 0,
          opacity: animationState === "outro" ? 1 : 0,
        }} lottieRef={lottieOutroRef} loop={true} autoplay={true} animationData={intro}></Lottie>
      </div> */}
      

      <div
        className={`${animationState === "intro" ? "transitionScreenBefore " : ""} ${
          animationState === "outro" ? "transitionScreenAfter " : ""
        } fixed z-50 inset-0  pointer-events-none`}
      />
      {displayChildren}
    </>
  );
}
